<script>
import router from "@/router";
import simplebar from "simplebar-vue";

import {
  layoutComputed
} from "@/state/helpers";
import Menu from "@/components/menu.vue";
import NavBar from "@/components/nav-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import AuthHelper from "@/helpers/auth-helper";

/**
 * Vertical layout
 */
export default {
  components: {
    NavBar,
    RightBar,
    Footer,
    Menu,
    simplebar
  },
  data() {
    return {
      isMenuCondensed: false,
      rmenu: localStorage.getItem('rmenu') ? localStorage.getItem('rmenu') : 'twocolumn',
      userPermissions: [], // Stocker les permissions de l'utilisateur
    };
  },

  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  mounted() {
    this.loadUserPermissions();
    this.initActiveMenu();
    if (this.rmenu == 'vertical' && this.layoutType == 'twocolumn') {
      document.documentElement.setAttribute("data-layout", "vertical");
    }
    document.getElementById('overlay').addEventListener('click', () => {
      document.body.classList.remove('vertical-sidebar-enable');
    });

    window.addEventListener("resize", () => {
      if (this.layoutType == 'twocolumn') {
        var windowSize = document.documentElement.clientWidth;
        if (windowSize < 767) {
          document.documentElement.setAttribute("data-layout", "vertical");
          this.rmenu = 'vertical';
          localStorage.setItem('rmenu', 'vertical');
        } else {
          document.documentElement.setAttribute("data-layout", "twocolumn");
          this.rmenu = 'twocolumn';
          localStorage.setItem('rmenu', 'twocolumn');
          setTimeout(() => {
            this.initActiveMenu();
          }, 50);

        }
      }
    });
    this.initMenuEvents();
  },
  methods: {
    // Charger les permissions de l'utilisateur
    loadUserPermissions() {
      const permissions = AuthHelper.getPermissions();
      try {
        this.userPermissions = permissions ? JSON.parse(permissions) : [];
      } catch (error) {
        console.error("Erreur lors du parsing des permissions:", error);
        this.userPermissions = [];
      }
    },

    // Vérifier si l'utilisateur a une permission spécifique
    hasPermission(permission) {
      if (!permission) return true;
      return this.userPermissions.includes(permission);
    },

    // Vérifier si l'utilisateur a au moins une des permissions
    hasAnyPermission(permissions) {
      if (!permissions || permissions.length === 0) return true;
      return permissions.some(permission => this.userPermissions.includes(permission));
    },

    initMenuEvents() {
      if (document.querySelectorAll(".navbar-nav .collapse")) {
        let collapses = document.querySelectorAll(".navbar-nav .collapse");

        collapses.forEach((collapse) => {
          // Hide sibling collapses on `show.bs.collapse`
          collapse.addEventListener("show.bs.collapse", (e) => {
            e.stopPropagation();
            let closestCollapse = collapse.parentElement.closest(".collapse");
            if (closestCollapse) {
              let siblingCollapses =
                closestCollapse.querySelectorAll(".collapse");
              siblingCollapses.forEach((siblingCollapse) => {
                if (siblingCollapse.classList.contains("show")) {
                  siblingCollapse.classList.remove("show");
                  siblingCollapse.parentElement.firstChild.setAttribute("aria-expanded", "false");
                }
              });
            } else {
              let getSiblings = (elem) => {
                // Setup siblings array and get the first sibling
                let siblings = [];
                let sibling = elem.parentNode.firstChild;
                // Loop through each sibling and push to the array
                while (sibling) {
                  if (sibling.nodeType === 1 && sibling !== elem) {
                    siblings.push(sibling);
                  }
                  sibling = sibling.nextSibling;
                }
                return siblings;
              };
              let siblings = getSiblings(collapse.parentElement);
              siblings.forEach((item) => {
                if (item.childNodes.length > 2) {
                  item.firstElementChild.setAttribute("aria-expanded", "false");
                  item.firstElementChild.classList.remove("active");
                }
                let ids = item.querySelectorAll("*[id]");
                ids.forEach((item1) => {
                  item1.classList.remove("show");
                  item1.parentElement.firstChild.setAttribute("aria-expanded", "false");
                  item1.parentElement.firstChild.classList.remove("active");
                  if (item1.childNodes.length > 2) {
                    let val = item1.querySelectorAll("ul li a");

                    val.forEach((subitem) => {
                      if (subitem.hasAttribute("aria-expanded"))
                        subitem.setAttribute("aria-expanded", "false");
                    });
                  }
                });
              });
            }
          });

          // Hide nested collapses on `hide.bs.collapse`
          collapse.addEventListener("hide.bs.collapse", (e) => {
            e.stopPropagation();
            let childCollapses = collapse.querySelectorAll(".collapse");
            childCollapses.forEach((childCollapse) => {
              let childCollapseInstance = childCollapse;
              childCollapseInstance.classList.remove("show");
              childCollapseInstance.parentElement.firstChild.setAttribute("aria-expanded", "false");
            });
          });
        });
      }
    },

    initActiveMenu() {
      const pathName = window.location.pathname;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"));
        let activeItems = items.filter((x) => x.classList.contains("active"));
        this.removeActivation(activeItems);
        let matchingMenuItem = items.find((x) => {
          return x.getAttribute("href") === pathName;
        });
        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem);
        } else {
          var id = pathName.replace("/", "");
          if (id) document.body.classList.add("twocolumn-panel");
          this.activateIconSidebarActive(pathName);
        }
      }
    },

    updateMenu(e, event) {
      document.body.classList.remove("twocolumn-panel");
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll(".show"));
        items.forEach((item) => {
          item.classList.remove("show");
        });
      }
      const icons = document.getElementById("two-column-menu");
      if (icons) {
        const activeIcons = Array.from(
          icons.querySelectorAll(".nav-icon.active")
        );
        activeIcons.forEach((item) => {
          item.classList.remove("active");
        });
      }
      document.getElementById(e).classList.add("show");
      event.target.classList.add("active")
      this.activateIconSidebarActive("#" + e);
    },

    removeActivation(items) {
      items.forEach((item) => {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false);
          }
          item.nextElementSibling.classList.remove("show");
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove("show");
          }
          item.setAttribute("aria-expanded", false);
        }
        item.classList.remove("active");
      });
    },

    activateIconSidebarActive(id) {
      var menu = document.querySelector(
        "#two-column-menu .simplebar-content-wrapper a[href='" +
        id +
        "'].nav-icon"
      );
      if (menu !== null) {
        menu.classList.add("active");
      }
    },

    activateParentDropdown(item) {
      // navbar-nav menu add active
      item.classList.add("active");
      let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
      if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
        if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
          if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling) {
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown")) {
              const grandparent = parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown");
              this.activateIconSidebarActive("#" + grandparent.getAttribute("id"));
              grandparent.classList.add("show");
            }
          }
          this.activateIconSidebarActive("#" + parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
            .getAttribute("id"));

          parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
          if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
            parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
          return false;
        }
        this.activateIconSidebarActive("#" + parentCollapseDiv.getAttribute("id"));
        return false;
      }
      return false;
    },

    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },

    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },

    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <div>
      <!-- ========== Left Sidebar Start ========== -->
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/mepci.svg" alt="" height="42" />
            </span>
            <!-- <span class="logo-lg">
              <img src="@/assets/images/mepci.svg" alt="" height="37" />
            </span> -->
          </router-link>
          <!-- Light Logo-->
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/mepci.svg" alt="" height="42" />
            </span>
            <!-- <span class="logo-lg">
              <img src="@/assets/images/mepci.svg" alt="" height="37" />
            </span> -->
          </router-link>
          <BButton variant="link" size="sm" class="p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover">
            <i class="ri-record-circle-line"></i>
          </BButton>
        </div>

        <div id="scrollbar" v-if="rmenu == 'twocolumn'">
          <BContainer fluid>
            <div id="two-column-menu">
              <simplebar class="twocolumn-iconview list-unstyled">
                <BLink class="logo"><img src="@/assets/images/mepci.svg" alt="Logo" height="22" /></BLink>

                <!-- Icônes du menu deux colonnes avec conditions de permission -->
                <li v-if="hasAnyPermission(['report:read', 'report:generate', 'report:write'])">
                  <BLink href="#sidebarDashboards" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarDashboards', $event)">
                    <i class="ri-dashboard-2-line"></i>
                  </BLink>
                </li>

                <li
                  v-if="hasAnyPermission(['ticket:read', 'post:read', 'task:read', 'meeting:read', 'workflows', 'report:read'])">
                  <BLink href="#sidebarApps" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarApps', $event)">
                    <i class="ri-apps-2-line"></i>
                  </BLink>
                </li>

                <li v-if="hasAnyPermission(['person:read', 'user:read', 'employee:read'])">
                  <BLink href="#sidebarPeople" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarPeople', $event)">
                    <i class="ri-team-line"></i>
                  </BLink>
                </li>

                <li v-if="hasAnyPermission(['employee:read', 'configuration:hr', 'parameter:hr'])">
                  <BLink href="#sidebarHR" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarHR', $event)">
                    <i class="ri-user-settings-line"></i>
                  </BLink>
                </li>

                <li v-if="hasAnyPermission(['institution:read', 'structure:read', 'partners', 'groups'])">
                  <BLink href="#sidebarOrganization" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarOrganization', $event)">
                    <i class="ri-building-line"></i>
                  </BLink>
                </li>

                <li v-if="hasAnyPermission(['document:read', 'folder:read', 'keywords', 'file:types', 'templates'])">
                  <BLink href="#sidebarDocuments" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarDocuments', $event)">
                    <i class="ri-file-text-line"></i>
                  </BLink>
                </li>

                <li
                  v-if="hasAnyPermission(['permissions', 'role:read', 'attributes', 'product:categories', 'event:types'])">
                  <BLink href="#sidebarConfig" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarConfig', $event)">
                    <i class="ri-settings-line"></i>
                  </BLink>
                </li>

                <li
                  v-if="hasAnyPermission(['parameter:user', 'parameter:notification', 'parameter:document', 'parameter:hr', 'parameter:meeting', 'parameter:post', 'parameter:ticket', 'parameter:workflow'])">
                  <BLink href="#sidebarParameters" class="nav-icon" role="button"
                    @click.prevent="updateMenu('sidebarParameters', $event)">
                    <i class="ri-settings-5-fill"></i>
                  </BLink>
                </li>
              </simplebar>
            </div>

            <template v-if="layoutType === 'twocolumn'">
              <simplebar class="navbar-nav" id="navbar-nav">
                <li class="menu-title">
                  <span data-key="t-menu"> {{ $t("t-menu") }}</span>
                </li>

                <!-- Drive - Visible pour tous -->
                <li class="nav-item">
                  <router-link to="/drive" class="nav-link menu-link">
                    <i class="ri-drive-line"></i>
                    <span data-key="t-my-drive"> {{ $t("t-my-drive") }}</span>
                  </router-link>
                </li>

                <!-- Organigramme - Visible pour tous les utilisateurs connectés -->
                <li class="nav-item" v-if="hasAnyPermission(['structure:read'])">
                  <router-link to="/structures-organigramme" class="nav-link menu-link">
                    <i class="ri-organization-chart"></i>
                    <span data-key="t-organigramme"> {{ $t("t-organigramme") }}</span>
                  </router-link>
                </li>

                <!-- Tableaux de bord -->
                <li class="nav-item" v-if="hasAnyPermission(['report:read', 'report:generate', 'report:write'])">
                  <div class="collapse menu-dropdown" id="sidebarDashboards">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item">
                        <router-link to="/" class="nav-link" data-key="t-dashboards">
                          {{ $t("t-dashboards") }}
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/activity-dashboard" class="nav-link" data-key="t-activity">
                          {{ $t("t-activity") }}
                        </router-link>
                      </li>
                      <li class="nav-item">
                        <router-link to="/app-dashboard" class="nav-link" data-key="t-app">
                          {{ $t("t-app") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Applications -->
                <li class="nav-item"
                  v-if="hasAnyPermission(['ticket:read', 'post:read', 'task:read', 'meeting:read', 'workflows', 'report:read'])">
                  <div class="collapse menu-dropdown" id="sidebarApps">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasAnyPermission(['ticket:read', 'ticket:write', 'ticket:admin'])">
                        <router-link to="/ticket" class="nav-link" data-key="t-tickets">
                          {{ $t("t-tickets") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['post:read', 'post:write', 'post:publish'])">
                        <router-link to="/posts" class="nav-link" data-key="t-posts">
                          {{ $t("t-posts") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['task:read', 'task:write'])">
                        <router-link to="/tasks" class="nav-link" data-key="t-tasks">
                          {{ $t("t-tasks") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['meeting:read', 'meeting:write'])">
                        <router-link to="/meetings" class="nav-link" data-key="t-meetings">
                          {{ $t("t-meetings") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['workflows', 'workflow:instance'])">
                        <router-link to="/workflows" class="nav-link" data-key="t-workflows">
                          {{ $t("t-workflows") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['report:read', 'report:generate'])">
                        <router-link to="/report" class="nav-link" data-key="t-report">
                          {{ $t("t-report") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Gestion des Personnes -->
                <li class="nav-item" v-if="hasAnyPermission(['person:read', 'user:read', 'employee:read'])">
                  <div class="collapse menu-dropdown" id="sidebarPeople">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasPermission('person:read')">
                        <router-link to="/person" class="nav-link" data-key="t-person">
                          {{ $t("t-person") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['user:read', 'user:write'])">
                        <router-link to="/user-management" class="nav-link" data-key="t-users">
                          {{ $t("t-users") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/employee" class="nav-link" data-key="t-employee">
                          {{ $t("t-employee") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Ressources Humaines -->
                <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'configuration:hr', 'parameter:hr'])">
                  <div class="collapse menu-dropdown" id="sidebarHR">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/grades" class="nav-link" data-key="t-grades">
                          {{ $t("t-grades") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/echelons" class="nav-link" data-key="t-echelons">
                          {{ $t("t-echelons") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/hierarchies" class="nav-link" data-key="t-hierarchies">
                          {{ $t("t-hierarchies") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/diplomas" class="nav-link" data-key="t-diplomas">
                          {{ $t("t-diplomas") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/professions" class="nav-link" data-key="t-professions">
                          {{ $t("t-professions") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/jobCategories" class="nav-link" data-key="t-jobCategories">
                          {{ $t("t-jobCategories") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/status" class="nav-link" data-key="t-status">
                          {{ $t("t-status") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/jobs" class="nav-link" data-key="t-jobs">
                          {{ $t("t-jobs") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/missions" class="nav-link" data-key="t-missions">
                          {{ $t("t-missions") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('configuration:hr')">
                        <router-link to="/formations" class="nav-link" data-key="t-formations">
                          {{ $t("t-formations") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/holidays" class="nav-link" data-key="t-holidays">
                          {{ $t("t-holidays") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/leaves" class="nav-link" data-key="t-leaves">
                          {{ $t("t-leaves") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/sanctions" class="nav-link" data-key="t-sanctions">
                          {{ $t("t-sanctions") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/inactivities" class="nav-link" data-key="t-inactivities">
                          {{ $t("t-inactivities") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/departures" class="nav-link" data-key="t-departures">
                          {{ $t("t-departures") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                        <router-link to="/denunciations" class="nav-link" data-key="t-denunciations">
                          {{ $t("t-denunciations") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('knowledges')">
                        <router-link to="/knowledge" class="nav-link" data-key="t-knowledge">
                          {{ $t("t-knowledge") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Organisations et Structures -->
                <li class="nav-item"
                  v-if="hasAnyPermission(['institution:read', 'structure:read', 'partners', 'groups'])">
                  <div class="collapse menu-dropdown" id="sidebarOrganization">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasAnyPermission(['institution:read', 'institution:write'])">
                        <router-link to="/institution" class="nav-link" data-key="t-institution">
                          {{ $t("t-institution") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('institution:types')">
                        <router-link to="/institution-type" class="nav-link" data-key="t-institutionsType">
                          {{ $t("t-institutionsType") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['structure:read', 'structure:write'])">
                        <router-link to="/structures" class="nav-link" data-key="t-structures">
                          {{ $t("t-structures") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('partners')">
                        <router-link to="/partners" class="nav-link" data-key="t-partners">
                          {{ $t("t-partners") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('groups')">
                        <router-link to="/group" class="nav-link" data-key="t-groups">
                          {{ $t("t-groups") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Gestion des Documents -->
                <li class="nav-item"
                  v-if="hasAnyPermission(['document:read', 'folder:read', 'keywords', 'file:types', 'templates'])">
                  <div class="collapse menu-dropdown" id="sidebarDocuments">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasPermission('document:categories')">
                        <router-link to="/category-document" class="nav-link" data-key="t-categoryDocuments">
                          {{ $t("t-categoryDocuments") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('keywords')">
                        <router-link to="/keyword" class="nav-link" data-key="t-keywords">
                          {{ $t("t-keywords") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['document:read', 'document:write'])">
                        <router-link to="/files" class="nav-link" data-key="t-files">
                          {{ $t("t-files") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('report:types')">
                        <router-link to="/reports-type" class="nav-link" data-key="t-report-type">
                          {{ $t("t-report-type") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('templates')">
                        <router-link to="/template-types/" class="nav-link" data-key="t-templateTypes">
                          {{ $t("t-templateTypes") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('templates')">
                        <router-link to="/template-bloc/" class="nav-link" data-key="t-templateBloc">
                          {{ $t("t-templateBloc") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('templates')">
                        <router-link to="/template/" class="nav-link" data-key="t-template">
                          {{ $t("t-template") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Configuration Système -->
                <li class="nav-item"
                  v-if="hasAnyPermission(['permissions', 'role:read', 'attributes', 'product:categories', 'event:types'])">
                  <div class="collapse menu-dropdown" id="sidebarConfig">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-if="hasPermission('permissions')">
                        <router-link to="/permissions" class="nav-link" data-key="t-permissions">
                          {{ $t("t-permissions") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasAnyPermission(['role:read', 'role:write'])">
                        <router-link to="/roles" class="nav-link" data-key="t-roles">
                          {{ $t("t-roles") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('attributes')">
                        <router-link to="/attributes" class="nav-link" data-key="t-attributes">
                          {{ $t("t-attributes") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('product:categories')">
                        <router-link to="/products" class="nav-link" data-key="t-products">
                          {{ $t("t-products") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('parameter:hr')">
                        <router-link to="/pays" class="nav-link" data-key="t-pays">
                          {{ $t("t-pays") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('event:types')">
                        <router-link to="/events" class="nav-link" data-key="t-events">
                          {{ $t("t-events") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('ticket:categories')">
                        <router-link to="/category-ticket" class="nav-link" data-key="t-Categorie-ticket">
                          {{ $t("t-Categorie-ticket") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('support:types')">
                        <router-link to="/support-type" class="nav-link" data-key="t-supportTypes">
                          {{ $t("t-supportTypes") }}
                        </router-link>
                      </li>
                      <li class="nav-item" v-if="hasPermission('parameter:document')">
                        <router-link to="/movement-type" class="nav-link" data-key="t-movementType">
                          {{ $t("t-movementType") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>

                <!-- Paramètres Généraux -->
                <li class="nav-item"
                  v-if="hasAnyPermission(['parameter:user', 'parameter:notification', 'parameter:document', 'parameter:hr', 'parameter:meeting', 'parameter:post', 'parameter:ticket', 'parameter:workflow'])">
                  <div class="collapse menu-dropdown" id="sidebarParameters">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item">
                        <router-link to="/parameters" class="nav-link" data-key="t-parameters">
                          {{ $t("t-parameters") }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
              </simplebar>
            </template>
          </BContainer>
        </div>

        <simplebar id="scrollbar" class="h-100" ref="scrollbar" v-if="rmenu == 'vertical'">
          <Menu></Menu>
        </simplebar>

        <div class="sidebar-background"></div>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div class="vertical-overlay" id="overlay"></div>
    </div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <BContainer fluid>
          <slot />
        </BContainer>
      </div>
      <Footer />
    </div>
    <RightBar />
  </div>
</template>